import apiClient from '@/utils/request'
import { IRequestPayload, IGeneralResponse } from '@/api/types'
import { nestedQueryFormatter } from '@/utils/query'

export interface IRegionAttributes {
  name: string
  geoip2_id: number
}

export interface IRegion {
  id: number
  type: 'region'
  attributes: IRegionAttributes
}

export interface IRegionsFilter {
  geoip2_id?: number[]
  name?: string
  target: string
  country_iso?: string[]
}

export interface IRegionsPayload extends IRequestPayload {
  filter: IRegionsFilter
}

export interface IRegionsResponse extends IGeneralResponse {
  data: Array<IRegion>
}

export interface Option {
  value: number
  key: number
  label: string
}

export const fetchItems = async (
  payload: IRegionsPayload
): Promise<IRegionsResponse> => {
  payload.filter = payload.filter || {}
  payload.filter.target = payload.filter.target || 'regions'
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.get<IRegionsResponse>(
    `/${payload.filter.target}/`,
    { params }
  )
  return response.data
}
